// 名师讲坛
import forumIndex from '@/views/study/forum/index'

const zsxxwRoutes = Array.from({ length: 19 }, (_, i) => ({
  path: `forum/zsxxw/index${i + 1}`,
  name: `forum/zsxxw/Index${i + 1}`,
  component: () => import(`@/views/study/forum/zsxxw/index${i + 1}.vue`)
}))

export default {
  path: '/study',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'forum/index',
      name: 'forumIndex',
      component: forumIndex
    },
    // 名师讲坛，开始
    ...zsxxwRoutes
    // 名师讲坛，结束

  ]
}
